import React from 'react';
import { Modal, Box, Typography, IconButton, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { FPRM } from './forcePasswordResetModal.classes';

type ResultModalProps = {
    open: boolean;
    onClose: () => void;
    resultData: any;
};

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    height: 300,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 2,
};

const ForcePasswordResetModal: React.FC<ResultModalProps> = ({ open, onClose, resultData }) => {
    const { t } = useTranslation();
    const handleCopy = () => {
        const text = `
${t('customerPasswordChange.totalRequestCount')}: ${resultData?.totalRequests}
${t('customerPasswordChange.successfulAccount')}: ${resultData?.successCount}
${t('customerPasswordChange.previouslyResetAccount')} ${resultData?.alreadyResetCount}
${t('customerPasswordChange.status')}:${resultData?.operationStatus ? 'True' : 'False'}
${t('customerPasswordChange.errorMessage')}: ${resultData?.errorMessageKeyword}
    `;
        navigator.clipboard.writeText(text);
        Swal.fire({
            icon: 'success',
            title: t('general.copied'),
            showConfirmButton: false,
            timer: 1500,
        });
    };

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                onClose();
            }}
        >
            <Box className={FPRM.surface} sx={style}>
                <Box className={FPRM.header} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography className={FPRM.title} variant="h6" fontWeight="bold">
                        {t('customerPasswordChange.processResponse')}
                    </Typography>
                    <IconButton className={FPRM.inputIconButtonClose} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Paper
                    className={FPRM.resultsPaper}
                    variant="outlined"
                    sx={{
                        mt: 2,
                        p: 2,
                        backgroundColor: '#f8f8f8',
                        whiteSpace: 'pre-line',
                        fontFamily: 'monospace',
                        position: 'relative',
                    }}
                >
                    <Typography className={FPRM.statTotalRequests} variant="body2">
                        {t('customerPasswordChange.totalRequestCount')}: {resultData?.totalRequests}
                    </Typography>
                    <Typography className={FPRM.statSuccessCount} variant="body2">
                        {t('customerPasswordChange.successfulAccount')}: {resultData?.successCount}
                    </Typography>
                    <Typography className={FPRM.statAlreadyReset} variant="body2">
                        {t('customerPasswordChange.previouslyResetAccount')}: {resultData?.alreadyResetCount}
                    </Typography>
                    <Typography className={FPRM.statOperationStatus} variant="body2">
                        {t('customerPasswordChange.status')}: {resultData?.operationStatus ? 'True' : 'False'}
                    </Typography>
                    <Typography className={FPRM.statErrorMessage} variant="body2">
                        {t('customerPasswordChange.errorMessage')}: {resultData?.errorMessageKeyword}
                    </Typography>

                    <IconButton
                        className={FPRM.inputIconButtonCopy}
                        onClick={handleCopy}
                        sx={{ position: 'absolute', right: 8, bottom: 8 }}
                        size="small"
                    >
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </Paper>
            </Box>
        </Modal>
    );
};

export default ForcePasswordResetModal;
